import { ButtonTheme } from 'components/Button';
import { ICONS } from 'components/Icon';
import { Menu } from 'components/Menu';
import React from 'react';
import { StyleSheet } from 'react-native';

interface Props {
  value?: string;
  options: { id: string; name: string }[];
  onChange: (id: string) => void;
  disabled?: boolean;
}

export const OrganisationFilter: React.FC<Props> = ({
  onChange,
  options,
  value,
  disabled,
}) => {
  const handlePress = (id: string) => {
    onChange(id);
  };

  const label =
    options.find((option) => option.id === value)?.name || 'Organisations';

  return (
    <Menu
      buttonConfig={{
        buttonTheme: ButtonTheme.themeless,
        chipLike: true,
        textSize: 'small',
        style: styles.buttonStyle,
        text: label,
        iconRight: ICONS.CaretDownSolid,
        iconRightSize: 12,
        disabled,
      }}
      options={options.map((option) => ({
        icon:
          option.id === value || (option.id === '0' && value === undefined)
            ? ICONS.CheckLight
            : undefined,
        key: option.id,
        onPress: () => handlePress(option.id),
        text: option.name,
      }))}
    />
  );
};

const styles = StyleSheet.create({
  buttonStyle: {
    maxWidth: 150,
  },
});
